import AriesTable from './AriesTable';

export default AriesTable;
